import { STATE_COLORS } from './statusColors';

// Inbox tokens mirrored from the backend (CleaningValidation.Domain.Constants.InboxConstants
// and NotificationModule). Keep in sync with the C# side.

export const INBOX_MODULES = {
  FMECA: 'Fmeca',
  NPA: 'Npa',
  PROTOCOL: 'Protocol',
  RISK: 'Risk',
  VISUAL_INSPECTION: 'VisualInspection',
};

// Group headers + display order for the module-grouped To-Do list.
export const MODULE_LABELS = {
  [INBOX_MODULES.FMECA]: 'FMECA Assessments',
  [INBOX_MODULES.NPA]: 'New Product Assessments',
  [INBOX_MODULES.PROTOCOL]: 'Validation/Verification',
  [INBOX_MODULES.RISK]: 'Risk Register',
  [INBOX_MODULES.VISUAL_INSPECTION]: 'Visual Inspection',
};

export const MODULE_ORDER = [
  INBOX_MODULES.FMECA,
  INBOX_MODULES.NPA,
  INBOX_MODULES.PROTOCOL,
  INBOX_MODULES.RISK,
  INBOX_MODULES.VISUAL_INSPECTION,
];

export const INBOX_STATUS = {
  ASSESSMENT_REVIEW: 'AssessmentReview',
  FINAL_REVIEW: 'FinalReview',
  NPA_REVIEW: 'NpaReview',
  PROTOCOL_REVIEW: 'ProtocolReview',
  RETURNED: 'Returned',
  ACTION: 'Action',
  OVERDUE: 'Overdue',
  QUALIFICATION_REVIEW: 'QualificationReview',
  INSPECTOR_DUE_SOON: 'InspectorDueSoon',
  INSPECTOR_LAPSED: 'InspectorLapsed',
  VRL_STUDY_REVIEW: 'VrlStudyReview',
  RANKING_STUDY_REVIEW: 'RankingStudyReview',
  MISSED_VISUAL_RESIDUE: 'MissedVisualResidue',
};

// Row chip: user-facing label + MUI Chip colour. Statuses use plain workflow words (no L1/L2).
export const STATUS_META = {
  [INBOX_STATUS.ASSESSMENT_REVIEW]: { label: 'Assessment Review', color: 'primary' },
  [INBOX_STATUS.FINAL_REVIEW]: { label: 'Final Review', color: 'warning' },
  [INBOX_STATUS.NPA_REVIEW]: { label: 'Review', color: 'primary' },
  [INBOX_STATUS.PROTOCOL_REVIEW]: { label: 'Review', color: 'primary' },
  [INBOX_STATUS.RETURNED]: { label: 'Returned', color: 'error' },
  [INBOX_STATUS.ACTION]: { label: 'Action', color: 'success' },
  [INBOX_STATUS.OVERDUE]: { label: 'Overdue', color: 'error' },
  [INBOX_STATUS.QUALIFICATION_REVIEW]: { label: 'Qualification Review', color: 'primary' },
  [INBOX_STATUS.INSPECTOR_DUE_SOON]: { label: 'Due Soon', color: STATE_COLORS.INPROGRESS },
  [INBOX_STATUS.INSPECTOR_LAPSED]: { label: 'Lapsed', color: STATE_COLORS.ERROR },
  [INBOX_STATUS.VRL_STUDY_REVIEW]: { label: 'VRL Study Review', color: 'primary' },
  [INBOX_STATUS.RANKING_STUDY_REVIEW]: { label: 'Ranking Study Review', color: 'primary' },
  [INBOX_STATUS.MISSED_VISUAL_RESIDUE]: { label: 'Missed Residue', color: STATE_COLORS.ERROR },
};

// Notification module → accent colour for the bell/History icon.
export const NOTIFICATION_MODULE_COLOR = {
  [INBOX_MODULES.FMECA]: 'primary.main',
  [INBOX_MODULES.NPA]: 'primary.main',
  [INBOX_MODULES.PROTOCOL]: 'primary.main',
  [INBOX_MODULES.RISK]: 'success.main',
  [INBOX_MODULES.VISUAL_INSPECTION]: 'primary.main',
};
